import { useField, useFormikContext } from 'formik';
import { Button } from '../Button';
import { Add } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';
import { ClaimCorrectionFormType } from '@uplift/types';

export type FieldToggleButtonProps = {
  name: string;
  label: React.ReactNode;
};

export const FieldToggleButton: React.FC<FieldToggleButtonProps> = ({ name, label }) => {
  const { classes } = useStyles();
  const formik = useFormikContext<ClaimCorrectionFormType>();
  const [ field ] = useField(name);

  const handleClick = () => {
    formik.setFieldValue(name, true);
  };

  if (field.value === true) {
    return null;
  }

  return (
    <Button
      variant="text"
      onClick={handleClick}
      startIcon={<Add />}
      color="secondary"
      className={classes.button}
    >
      {label}
    </Button>
  );
};

const useStyles = makeStyles()(() => ({
  button: {
    justifyContent: 'flex-start',
  }
}));
